import { render, staticRenderFns } from "./InvoiceManageCrud2.vue?vue&type=template&id=626f6d72&"
import script from "./InvoiceManageCrud2.vue?vue&type=script&lang=js&"
export * from "./InvoiceManageCrud2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports